<template>
    <div class="activity-rules">
        <van-popup v-model="visible"
            position="bottom"
            closeable
            round
            :style="{ height: '70%' }">
            <div class="title">活动规则</div>
            <div class="content"
                v-html="ruleDesc"></div>
        </van-popup>
    </div>
</template>
<script>
import { Popup } from 'vant';

export default {
  name: 'ActivityRules',
  components: { Popup },
  props: {
    ruleDesc: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      visible: false,
    };
  },
  methods: {
    show() {
      this.visible = true;
    },
    close() {
      this.visible = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.activity-rules {
  .title {
    margin-top: 16px;
    font-size: 18px;
    text-align: center;
    font-weight: bold;
    margin-bottom: 15px;
  }
  .content {
    padding: 0 15px;
    font-size: 14px;
    line-height: 1.5;
  }
}
</style>


// WEBPACK FOOTER //
// src/page/vibrantRubikCube/runtime/topicPK/activity-rules.vue